module.exports = __webpack_public_path__ + "static/media/enhance.fef0294f.svg";